/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { DefecationJson } from '@/types/domain/defecation/entities/defecationEntity';
import type { DefecationStateType } from '@/types/domain/defecation/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: DefecationStateType = {
  defecationList: [],
  nextToken: null,
};

/**
 * 排泄Slice
 */
export const defecationSlice = createSlice({
  name: 'defecation',
  initialState,
  reducers: {
    /** 排泄リストをセットする */
    setDefecationList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: DefecationJson[],
      }>) => {
        state.defecationList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** 排泄ストア作成 */
    createDefecationStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.defecationList = service.defecation.createDefecationStore(
        state.defecationList,
        action.payload,
        undefined,
      );
    },
    /** 排泄ストア更新 */
    updateDefecationStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.defecationList = service.defecation.updateDefecationStore(
        state.defecationList,
        action.payload,
      );
    },
    /** 排泄ストア削除 */
    deleteDefecationStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.defecationList = service.defecation.deleteDefecationStore(
        state.defecationList,
        action.payload,
      );
    },
  },
});
